export default __webpack_public_path__ + "static/media/ennovate_9.e1d1906c.jpg";